import uuid from 'node-uuid';
import moment from 'moment';
import "./Tile";

/** @namespace GIS.Map.Layer */
NS("GIS.Map.Layer");

/**
 * @class
 * @extends GIS.Map.Layer.Tile
 *
 * todo implement through Google API
 */
GIS.Map.Layer.Google = Class(GIS.Map.Layer.Tile, /** @lends GIS.Map.Layer.Google.prototype */ {
    title: "Google Tiles",
    attributions: ["Картографические данные © Google, " + moment().format('YYYY')],
    maxZoom: 20,
    layerName: 'mt',
    projection: 'EPSG:3857',
    url: "http://{layerName}{0-3}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}",
    /** @inheritDoc */
    initialize()
    {
        this.ParentCall();
        this.name = "GIS.Map.Layer.Google:" + uuid.v4();
    }
});
